import { yupResolver } from "@hookform/resolvers/yup";
import { Resolver } from "react-hook-form";
import { object, string } from "yup";
import { UploadVideoForm } from "./types";

const schema = object({
  image: string().trim().nullable().required("Image is required"),
  video: string().trim().nullable().required("Video is required"),
}).required();

export const resolver: Resolver<UploadVideoForm> = yupResolver(
  schema,
) as Resolver<UploadVideoForm>;
